import {
  SearchActionType,
  SearchNameType,
  SearchTypeTypes,
  trackOriginClick,
  trackSearch,
} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

export const useTrackSearch = () => {
  const {TrackingClient} = useTracking();

  return ({
    searchTerm,
    searchName,
    searchAction,
    searchType,
    searchTermCompleted,
    searchDestination,
    searchId,
    searchVersion,
  }: {
    searchTerm?: string;
    searchName?: SearchNameType;
    searchAction: SearchActionType;
    searchType?: SearchTypeTypes;
    searchTermCompleted?: string | null;
    searchDestination?: string;
    searchId?: string;
    searchVersion?: string;
  }) => {
    TrackingClient.track(trackOriginClick({origin: 'search'}));
    TrackingClient.track(() =>
      trackSearch({
        label: searchTerm || '',
        action: searchAction,
        name: searchName || '',
        searchTermCompleted: searchTermCompleted || '',
        searchDestination: searchDestination || '',
        searchType: searchType || '',
        searchId,
        searchVersion,
      }),
    );
  };
};

export const useSearchEventsUtils = () => {
  const {
    updateSearchEventParams,
    getSearchEventParams,
    resetSearchEventParams,
  } = useTracking();

  return {
    updateSearchEventContextParams: updateSearchEventParams,
    getSearchEventContextParams: getSearchEventParams,
    resetEventContextParams: resetSearchEventParams,
  };
};
